// Marker class for a grouped list to indicate that there are no results.
export class NoItemsRow {}
